function desktopBridge() {
    return typeof window === 'undefined'
        ? undefined
        : window.MalkaDesktop;
}
export function showDesktopWindow() {
    const bridge = desktopBridge();
    if (typeof bridge?.showWindow === 'function') {
        bridge.showWindow();
    }
}
/**
 * This page has a live call: 'video' (a call room) or 'chat' (Relay,
 * captions). `onControl` gets 'hangup' (Hang up in the mini window or the
 * tray), 'mini' and 'expand'. Returns the function that ends the report
 * (the call ended, or the page leaves).
 *
 * @param {DesktopCallKind} kind - The kind of call.
 * @param {Function} onControl - Runs for each control from the app.
 * @returns {Function}
 */
export function registerDesktopCall(kind, onControl) {
    const bridge = desktopBridge();
    if (typeof bridge?.setCallSurface !== 'function') {
        return () => undefined;
    }
    bridge.setCallSurface(kind);
    const stop = typeof bridge.onCallControl === 'function' ? bridge.onCallControl(onControl) : undefined;
    return () => {
        if (typeof stop === 'function') {
            stop();
        }
        bridge.setCallSurface?.(null);
    };
}
